export default async (context) => {

    // получение настроек

    const settings = await context.$axios.get('/settings')

    // список цветов

    await context.$store.dispatch('settings/setBackgrounds', {
        backgrounds: settings.data[0].data
    })

    // скорость движения текста

    // let speedText = 1

    await context.$store.dispatch('settings/setSpeedText', {
        speed: settings.data[1].value
    })

    await context.$store.dispatch('settings/setNewSpeedText', {
        speed: settings.data[17].value
    })

    //  фоновое видео

    await context.$store.dispatch('settings/setBackgroundVideoMp4', {
        video: settings.data[2].video
    })


    await context.$store.dispatch('settings/setBackgroundVideoWebm', {
        video: settings.data[2].webm
    })

    // значения макс. символов

    // let maxSymbol = 30

    await context.$store.dispatch('settings/setMaxSymbol', {
        symbol: settings.data[3].value
    })

    // значения свободных секунд, для модерации

    // let freeSeconds = 3

    await context.$store.dispatch('settings/setFreeSeconds', {
        seconds: settings.data[6].value
    })

    // стоимость минуты воспроизведения

    // let defaultPrice = 500

    await context.$store.dispatch('settings/setDefaultPrice', {
        price: settings.data[4].value
    })

    // наценки на музыку

    // let priceMusic = 1.3

    await context.$store.dispatch('settings/setPriceMusic', {
        price: settings.data[5].value
    })

    // наценки за выходные дни

    // let priceWeekend = 1.2

    await context.$store.dispatch('settings/setPriceWeekend', {
        price: settings.data[7].coef
    })

    // наценки за праздничные дни

    // let priceHolidays = 1.3

    await context.$store.dispatch('settings/setPriceHolidays', {
        price: settings.data[8].coef
    })

    // наценки за прайм тайм время

    // let pricePrimeTime = 1.3

    await context.$store.dispatch('settings/setPricePrimeTime', {
        price: settings.data[9].coef
    })

    // цены на съемку с земли

    await context.$store.dispatch('settings/setPriceSurveyGround', {
        price: settings.data[10].price
    })

    // цены на съемку с воздуха

    await context.$store.dispatch('settings/setPriceSurveyAerial', {
        price: settings.data[11].price
    })

    // цены на съемку с земли и воздуха

    await context.$store.dispatch('settings/setPriceSurveyGroundAerial', {
        price: settings.data[12].price
    })

    // timeout для повторного запроса смс с кодом

    await context.$store.dispatch('settings/setWaitingPayment', {
        time: settings.data[13].time
    })

    // время бронирования

    await context.$store.dispatch('settings/setReserveTime', {
        time: settings.data[14].time
    })

    // максимальное кол-во блоков

    await context.$store.dispatch('settings/setMaxBlocks', settings.data[16].qty)
}